import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from './Cookies';
import Footer from './Footer';
import Header from './Header';
import HeaderMenu from './HeaderMenu';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import React, { useEffect, useState } from 'react';
import Share from './Share';
import Snackbar from '@mui/material/Snackbar';
import clsx from 'clsx';
import mainBg from '../assets/img/bg.jpg';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { fetchData, showSuccess } from '../common/app/actions';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslations } from '../common/hooks/useTranslations';
import { hideLoginPopup } from '../common/app/actions';
import LoginDialog from './LoginDialog';

interface IProps {
  children: React.ReactNode;
}

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      layoutContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: 'auto',
        minHeight: '100%',
        flex: 1,
        left: 0,
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden',
      },
      headerContainerStyle: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        minHeight: `${C.HEADER_HEIGHT + C.HEADER_MENU_HEIGHT}px`,
        zIndex: 10,
        justifyContent: 'center',
      },
      headerWrapperStyle: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: `${C.MAX_WIDTH}px`,
      },
      contentContainerStyle: {
        position: 'relative',
        maxWidth: `${C.MAX_WIDTH}px`,
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        zIndex: 100,
        background: COLORS.appBlockSand,
        // paddingBottom: '30px',
      },
      imgContainerStyle: {
        position: 'absolute',
        width: '100%',
        minHeight: '100%',
        flex: 1,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflow: 'hidden',
        background: COLORS.appLettersBg,
      },
      imgWrapperStyle: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '2600px',
        height: '1800px',
      },
      imgWrapperStyle2: {
        position: 'absolute',
        top: '1350px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '2600px',
        height: '1800px',
      },
      imgWrapperStyle3: {
        position: 'absolute',
        top: '2700px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '2600px',
        height: '1800px',
      },
      imgWrapperStyle4: {
        position: 'absolute',
        top: '4050px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: '2600px',
        height: '1800px',
      },
      imgStyle: {
        width: '100%',
        height: '100%',
        // objectFit: 'cover',
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
        flex: 1,
      },
      '@global': {
        '.MuiSnackbarContent-root': {
          background: `${COLORS.successGreen} !important`,
        },
      },
      shareStyle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '20px 30px',
        boxSizing: 'border-box',
      },
    })
);

const Layout = ({ children }: IProps): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const appData = useSelector((state: any) => state.app.appData);
  const successData = useSelector((state: any) => state.app.successData);
  const isLoginDialogOpen = useSelector(
    (state: any) => state.app.isLoginDialogOpen
  );
  const authData = useSelector((state: any) => state.app.authData);

  const shareText = useTranslations('share_text');

  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(fetchData(C.APP_DATA, { app: true }));
    dispatch(fetchData(C.TRANSLATIONS_DATA, { translations: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getContent = () => {
    if (!appData) {
      return (
        <div className={classes.contentContainerStyle}>
          <div className={classes.centerContainerStyle}>
            <CircularProgress />
          </div>
        </div>
      );
    }

    const isRoot = pathname === ROUTES.ROOT;

    return (
      <div className={classes.contentContainerStyle}>
        {children}
        {isRoot && (
          <div className={classes.shareStyle}>
            <Share
              title={'Gadsimta stāsti.'}
              text={shareText || ''}
              url={window.location.href}
            />
          </div>
        )}
      </div>
    );
  };

  const onSnackbarClose = () => {
    dispatch(showSuccess());
  };

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const onLoginClose = (event?: React.SyntheticEvent) => {
    event?.stopPropagation();
    event?.preventDefault();

    dispatch(hideLoginPopup());
  };

  return (
    <div className={classes.layoutContainerStyle}>
      <div className={classes.imgContainerStyle}>
        <div className={classes.imgWrapperStyle}>
          <img src={mainBg} alt="" className={classes.imgStyle} />
        </div>
        <div className={classes.imgWrapperStyle2}>
          <img src={mainBg} alt="" className={classes.imgStyle} />
        </div>
        <div className={classes.imgWrapperStyle3}>
          <img src={mainBg} alt="" className={classes.imgStyle} />
        </div>
        <div className={classes.imgWrapperStyle4}>
          <img src={mainBg} alt="" className={classes.imgStyle} />
        </div>
      </div>
      <div className={classes.headerContainerStyle}>
        <div className={classes.headerWrapperStyle}>
          <Header />
          <HeaderMenu />
        </div>
      </div>
      {getContent()}
      {successData && (
        <Snackbar
          ContentProps={{ className: classes.snackbarStyle }}
          autoHideDuration={10000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={Boolean(successData)}
          onClose={onSnackbarClose}
          // message={successData}
        >
          <Alert
            onClose={onSnackbarClose}
            severity="success"
            sx={{ width: '100%' }}
          >
            {successData}
          </Alert>
        </Snackbar>
      )}
      <Footer />
      <Cookies />
      {isLoginDialogOpen && !authData && <LoginDialog onClose={onLoginClose} />}
    </div>
  );
};

export default Layout;
